





















































































import { BEmbed, BImg, BLink } from "bootstrap-vue";
import { resolveTemplateButtonIcon } from "@/utils/templates";
import { computed, defineComponent, PropType } from "@vue/composition-api";
import { downloadFile, getFullPath } from "@/utils/assets";
import { useToast } from "vue-toastification/composition";
// @ts-ignore
import i18n from "@/libs/i18n";
import { CampaignAttachmentsInterface } from "@/views/modules/engage/interfaces/campaignAttachments";
import { resolveContentTypeIcon } from "@/utils/chats";
import {
    ButtonType,
    TemplateComponentButton,
    TemplateComponentsInterface,
    TemplateInterface,
} from "@/interfaces/template.interface";

export default defineComponent({
    components: {
        BImg,
        BEmbed,
        BLink,
    },
    props: {
        message: {
            type: String,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
        components: {
            type: Object as PropType<TemplateComponentsInterface>,
            required: false,
        },
        attachments: {
            type: Array,
            required: false,
        },
    },
    // @TODO: Vue absolutely refuses to recognize the type of components and instead changes it to unknown. This creates problems so this ugly fix for now
    setup(props: any) {
        const toast = useToast();
        const replyButtons = computed<TemplateComponentButton[]>(
            () => props.components?.buttons?.buttons.filter((button) => button.type === ButtonType.REPLY) ?? []
        );
        const actionButtons = computed<TemplateComponentButton[]>(
            () => props.components?.buttons?.buttons.filter((button) => button.type !== ButtonType.REPLY) ?? []
        );

        const textHeader = computed(() => props.components?.header);
        const footer = computed(() => props.components?.footer);

        const localDownloadFile = (campaignAttachment: CampaignAttachmentsInterface) => {
            return downloadFile(campaignAttachment).catch(() => toast.error(i18n.t("toast.read.error")));
        };

        return {
            replyButtons,
            actionButtons,
            resolveTemplateButtonIcon,
            getFullPath,
            localDownloadFile,
            resolveContentTypeIcon,
            textHeader,
            footer,
        };
    },
});
